import { useCallback } from "react";
import {
  type LaunchAssistantConfig,
  type LaunchConfiguratorConfig,
} from "../../../../../../feature/LaunchRelevantTool/ToolConfig";
import { C_SURFACE } from "~/common/components/icon/Colors";
import { Card, styled, Typography } from "@mui/material";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import { Link } from "~/common/components/Link";
import { useTranslation } from "react-i18next";

interface LaunchConfiguratorsSectionProps {
  configs: LaunchConfiguratorConfig[];
}

export const LaunchConfiguratorsSection = ({ configs }: LaunchConfiguratorsSectionProps) => {
  return configs.map(
    useCallback(
      ({ url, title, type, launchLabel }) => (
        <LaunchToolTile key={type} title={title} url={url} btnLabel={launchLabel} />
      ),
      [],
    ),
  );
};

interface LaunchAssistantsSectionProps {
  configs: LaunchAssistantConfig[];
}

export const LaunchAssistantsSection = ({ configs }: LaunchAssistantsSectionProps) => {
  return configs.map(
    useCallback(
      ({ url, title, type, launchLabel }) => (
        <LaunchToolTile key={type} title={title} url={url} btnLabel={launchLabel} />
      ),
      [],
    ),
  );
};

interface TileProps {
  title: string;
  btnLabel: string;
  url: string;
}

const LaunchToolTile = ({ title, btnLabel, url }: TileProps) => {
  const { t } = useTranslation();
  return (
    <StyledCard variant={"elevation"} elevation={1}>
      <BuildOutlinedIcon sx={{ mr: 1 }} />
      <Typography variant={"bodyLarge"} sx={{ mr: { tablet: 2 } }}>
        {t(title)}
      </Typography>
      <Link href={url}>{t(btnLabel)}</Link>
    </StyledCard>
  );
};

const StyledCard = styled(Card)(({ theme }) => ({
  padding: "16px",
  display: "flex",
  justifyContent: "center",
  background: C_SURFACE,
  [theme.breakpoints.down("tablet")]: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gridTemplateRows: "auto auto",
    placeItems: "center",
    "& > svg": {
      gridRow: "1 / 3",
    },
  },
}));
